"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MenuAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getCurrentMenu(locationID) {
        return await this.client.get(`/locations/${locationID}/current-menu`);
    }
    async getAllMenus(locationID, type) {
        return await this.client.get(`/locations/${locationID}/menus`, {
            type,
        });
    }
}
exports.default = MenuAPI;
//# sourceMappingURL=index.js.map